import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import Landing from '@/views/Landing'
import Login from '@/views/Login'
import Register from '@/views/Register'
import Home from '@/views/Home'
import Pembelian from '@/views/Pembelian'
import Supplier from '@/views/Supplier'
import SellerPage from '@/views/SellerPage'
import Product from '@/views/Product'
import TambahSaldo from '@/views/TambahSaldo'
import KonfirmasiDeposit from '@/views/KonfirmasiDeposit'
import Histories from '@/views/Histories'
import Casin from '@/views/admin/Casin'
import CashOut from '@/views/admin/CashOut'
import TransaksiAdmin from '@/views/admin/TransaksiAdmin'
import GantiPassword from '@/views/GantiPassword'
import ResetPassToken from '@/views/ResetPassToken'
import Profile from '@/views/Profile'
import ForgotPass from '@/views/ForgotPass'
import ActivateUser from '@/views/ActivateUser'
import Penjualan from '@/views/Penjualan'
import AccountBank from '@/views/admin/AccountBank'
import SellerRegistration from '@/views/SellerRegistration'
import UserManagement from '@/views/admin/UserManagement'
import CariSuplierdanProduk from '@/views/CariSuplierdanProduk'
import NewsFeed from '@/views/NewsFeed'
import MutasiBanks from '@/views/admin/MutasiBanks'
import Sliders from '@/views/admin/Sliders'
import AdminProduct from '@/views/admin/AdminProduct'
import ChatPage from '@/views/ChatPage'
import AdminDashBoard from '@/views/admin/AdminDashBoard'
import CCSuccess from '@/views/PaymentTopupSuccess.vue'
import PaymentTopupFailed from '@/views/PaymentTopupFailed.vue'
import SyaratKetentuan from '@/views/SyaratKetentuan.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'landing',
    component: Home
  }, {
    path: '/forgot',
    name: 'forgot',
    component: ForgotPass,
    meta: {
      public: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      public: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      public: true
    }
  },
  {
    path: '/activate/:token',
    meta: {
      public: true
    },
    component: ActivateUser
  },
  {
    path: '/resetpass/:token',
    meta: {
      public: true
    },
    component: ResetPassToken
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/trxpembelian',
    name: 'trxpembelian',
    component: Pembelian,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/penjualan',
    name: 'penjualan',
    component: Penjualan,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/supplier',
    name: 'supplier',
    component: Supplier,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/admdashboard',
    name: 'admdashboard',
    component: AdminDashBoard,
    meta: {
      public: false
    }
  },
  {
    path: '/supplier/:id',
    name: 'supplierpage',
    component: SellerPage,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/product',
    name: 'product',
    component: Product,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/chat',
    name: 'chat',
    component: ChatPage,
    meta: {
      public: false,
      breadcrumb: false
    }
  },
  {
    path: '/tambahsaldo',
    name: 'tambahsaldo',
    component: TambahSaldo,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/histori',
    name: 'histori',
    component: Histories,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/cashin',
    name: 'cashin',
    component: Casin,
    meta: {
      public: false,
      admin: true,
      breadcrumb: true
    }
  },
  {
    path: '/cashout',
    name: 'cashout',
    component: CashOut,
    meta: {
      public: false,
      admin: true,
      breadcrumb: true
    }
  },
  {
    path: '/account',
    name: 'account',
    component: AccountBank,
    meta: {
      public: false,
      admin: true,
      breadcrumb: true
    }
  },
  {
    path: '/mutasibank',
    name: 'mutasibank',
    component: MutasiBanks,
    meta: {
      public: false,
      admin: true,
      breadcrumb: true
    }
  },
  {
    path: '/trxadm',
    name: 'trxadm',
    component: TransaksiAdmin,
    meta: {
      public: false,
      admin: true,
      breadcrumb: true
    }
  },
  {
    path: '/admin/sliders',
    name: '/admin/sliders',
    component: Sliders,
    meta: {
      public: false,
      admin: true,
      breadcrumb: true
    }
  },
  {
    path: '/admin/products',
    name: '/admin/products',
    component: AdminProduct,
    meta: {
      public: false,
      admin: true,
      breadcrumb: true
    }
  },
  {
    path: '/feeds',
    name: 'feeds',
    component: NewsFeed,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/usermanagement',
    name: 'usermanagement',
    component: UserManagement,
    meta: {
      public: false,
      admin: true,
      breadcrumb: true
    }
  },
  {
    path: '/cari',
    name: 'cari',
    component: CariSuplierdanProduk,
    meta: {
      public: false,
      admin: false,
      breadcrumb: true
    }
  },
  {
    path: '/gantipassword',
    name: 'gantipassword',
    component: GantiPassword,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/regseller',
    name: 'regseller',
    component: SellerRegistration,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/confmdeposit/:id',
    name: 'confmdeposit',
    component: KonfirmasiDeposit,
    meta: {
      public: false,
      breadcrumb: true
    }
  }, {
    path: '/paymenttopup/success',
    name: 'paymenttopup_success',
    component: CCSuccess,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/paymenttopup/failure',
    name: 'paymenttopup_failed',
    component: PaymentTopupFailed,
    meta: {
      public: false,
      breadcrumb: true
    }
  },
  {
    path: '/syaratketentuan',
    name: 'syaratketentuan',
    component: SyaratKetentuan,
    meta: {
      public: false,
      breadcrumb: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  NProgress.done()
})

export default router
